/**
 * Task Input Validator
 * Validates task data before sending to Firestore
 */

export function validateTaskInput(raw) {
  const errors = [];

  const title = (raw.title || '').trim();
  if (!title) {
    errors.push('Title is required.');
  }

  const allowedPriorities = ['low', 'medium', 'high'];
  const priority = raw.priority && allowedPriorities.includes(raw.priority)
    ? raw.priority
    : 'medium';

  let estimatedAmount = null;
  if (raw.estimatedAmount !== undefined && raw.estimatedAmount !== null && raw.estimatedAmount !== '') {
    const num = Number(raw.estimatedAmount);
    if (!Number.isFinite(num) || num <= 0) {
      errors.push('Estimated amount must be a positive number when provided.');
    } else {
      estimatedAmount = num;
    }
  }

  const listId = (raw.listId || '').trim() || 'default';

  return {
    isValid: errors.length === 0,
    errors,
    parsed: {
      ...raw,
      title,
      priority,
      estimatedAmount,
      listId,
    },
  };
}
